import {
  Edit,
  SimpleForm,
  TextInput,
  AutocompleteArrayInput,
  useNotify,
  useRedirect,
} from "react-admin";
import { useEffect, useState } from "react";
import { apiUrl } from "../../apiendpoint";

export const UserGroupEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      notify("Not authenticated", { type: "warning" });
      return;
    }

    fetch(`${apiUrl}users`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch users");
        return res.json();
      })
      .then((data) => {
        setUsers(
          data.map((u) => ({
            id: u.id,
            name: u.name || u.email, // fallback if name missing
          }))
        );
      })
      .catch(() => notify("Failed to load users", { type: "error" }));
  }, [notify]);

  // Ensure user_ids is always an array
  const transform = (data) => ({
    ...data,
    user_ids: data.user_ids || [],
  });

  return (
    <Edit
      title="Edit User Group"
      {...props}
      transform={transform}
      mutationMode="pessimistic"
      redirect="/usergroups" // redirect after save
      mutationOptions={{
        onSuccess: (response) => {
          notify("User group updated successfully 🎉", { type: "success" });
          redirect("/usergroups");
          console.log("Mutation response:", response);
        },
        onError: (error) => {
          console.error("ERROR:", error);

          // Handle duplicate or backend-specific errors
          if (
            error?.message?.includes("duplicate key") ||
            error?.message?.includes("already exists")
          ) {
            notify(
              "Some users were already assigned, update successful 🎉",
              { type: "success" }
            );
            redirect("/usergroups");
            return;
          }

          notify("Error updating user group ❌", { type: "error" });
        },
      }}
    >
      <SimpleForm>
        {/* Group name (read-only) */}
        <TextInput source="group_name" disabled fullWidth />

        {/* Users */}
        <AutocompleteArrayInput
          source="user_ids"
          choices={users}
          optionText="name"
          optionValue="id"
          fullWidth
          format={(value) => value || []}
          parse={(value) => value || []}
        />
      </SimpleForm>
    </Edit>
  );
};